import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';

// core's IndexSidebar (species search, "Nouvelle discussion", the two
// homepage widgets) is meant for browsing/starting discussions - the
// homepage (routeName 'index') and an individual tag's own discussion list
// ('tag'). Anything else that happens to reuse or subclass IndexSidebar
// inherits every widget ever added to it too, even where none of them make
// sense: flarum-tags' own "liste des forums" page (TagsPage, routeName
// 'tags') reuses IndexSidebar directly for its sidebar, and
// flarum-messages' own MessagesSidebar *extends* IndexSidebar - its
// items() calls super.items() first (this same patched prototype method)
// before adding its own "Nouveau message" button - so /messages and
// /messages/:id (routeName 'messages'/'dialog') inherited them too,
// confirmed live (species search/random descriptions/upcoming events all
// showing up there).
//
// Allowlisting the two pages that actually want these, rather than
// denylisting each page found to wrongly inherit them one at a time (this
// file used to be hideSidebarWidgetsOnTagsPage.js, covering only 'tags') -
// a future page that reuses IndexSidebar the same way doesn't need its own
// bug report first this way. Registered last in champis-forum's own
// initializer list (see index.js) so it runs after every add() that put
// these keys there in the first place - extend() callbacks for the same
// hook run in registration order, and removing a key that hasn't been
// added yet is a silent no-op.
const INDEX_LIKE_ROUTES = ['index', 'tag'];

// fof/byobu's own PrivateDiscussionsPage.js also reuses IndexSidebar for
// /private (routeName 'byobuPrivate') - the same "another page's own
// items() call inherits every widget" problem this file's own docblock
// describes for flarum-messages' old MessagesSidebar. That extend() runs
// *before* this one (fof-byobu is enabled before champis-forum - see
// extensions_enabled) and does items.setContent('newDiscussion', ...) to
// swap in its own "start a private discussion" button - which the blanket
// removal below used to strip right back out a moment later, since
// 'byobuPrivate' isn't a real index-like route (confirmed live: reported
// as "no new-private-discussion button" right after flarum/messages was
// replaced with fof/byobu). Only 'newDiscussion' is exempted here, not the
// full INDEX_LIKE_ROUTES allowlist - the three homepage widgets below
// still don't belong on a private-messages list.
const ROUTES_WITH_OWN_NEW_DISCUSSION_BUTTON = [...INDEX_LIKE_ROUTES, 'byobuPrivate'];
export default function restrictSidebarWidgetsToIndexPages() {
  extend(IndexSidebar.prototype, 'items', function (items) {
    const routeName = app.current.get('routeName');
    if (!ROUTES_WITH_OWN_NEW_DISCUSSION_BUTTON.includes(routeName)) {
      items.remove('newDiscussion');
    }
    if (INDEX_LIKE_ROUTES.includes(routeName)) return;
    items.remove('champis-species-search');
    items.remove('champis-random-descriptions');
    items.remove('champis-upcoming-events');
  });
}